import { render, staticRenderFns } from "./sd2.vue?vue&type=template&id=764d40b0&scoped=true"
import script from "./sd2.vue?vue&type=script&lang=js"
export * from "./sd2.vue?vue&type=script&lang=js"
import style0 from "./sd2.vue?vue&type=style&index=0&id=764d40b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d40b0",
  null
  
)

export default component.exports